<div class="change-filter-card">
  <div class="change-filter-card__banner">
    <div class="change-filter-card__banner-top">
      <div class="change-filter-card__circle">
        <i class="change-filter-card__icon material-icon material-icon--orange">
          add_location_alt
        </i>
      </div>
    </div>
    <div class="change-filter-card__triangle"></div>
  </div>
  <div class="change-filter-card__main">
    <p
      class="change-filter-card__text"
      [innerHTML]="'similarObjects.modifySearch.text' | i18n"
    ></p>

    <button
      class="filled-button filled-button--full-width"
      (click)="openFilters()"
    >
      <i class="filled-button__icon material-icon material-icon--outlined">
        tune
      </i>

      <span class="filled-button__text">
        {{ 'similarObjects.modifySearch.button' | i18n }}
      </span>
    </button>
  </div>
</div>
